import { find } from 'lodash';
import moment from 'moment';
import RegexUtils from '../utils/RegexUtils';
import DateUtils from '../utils/DateUtils';

const validationData = [
  {
    inputName: 'name',
    regex: RegexUtils.regexes.accountName,
    minLength: 1,
    maxLength: 18,
  },
  {
    inputName: 'sort_code',
    regex: RegexUtils.regexes.number,
    minLength: 6,
    maxLength: 6,
  },
  {
    inputName: 'display_name',
    regex: RegexUtils.regexes.accountName,
    minLength: 1,
    maxLength: 18,
  },
  {
    inputName: 'reference',
    regex: RegexUtils.regexes.accountName,
    minLength: 1,
    maxLength: 18,
  },
  {
    inputName: 'account_number',
    regex: RegexUtils.regexes.number,
    minLength: 8,
    maxLength: 8,
  },
  {
    inputName: 'amount',
    regex: RegexUtils.regexes.decimalNumber,
    minLength: 1,
    maxLength: 13,
  },
  {
    inputName: 'noOfTimes',
    regex: RegexUtils.regexes.number,
    minLength: 1,
    maxLength: 3,
  },
];

const ValidationConfig = {
  // Geting validtaion object for the input Name
  getValidationObjet(inputName) {
    return find(validationData, { inputName });
  },
  // Validating the input and its value
  validateData(name, value) {
    const validationResult = {
      isValid: true,
      minLengthValid: true,
      maxLengthValid: true,
      regexValid: true,
    };
    // getting the validation object
    const validationCriteria = this.getValidationObjet(name);
    if (validationCriteria === undefined) {
      validationResult.isValid = true;
    } else {
      // Check if regex is valid
      if (!RegexUtils.isValid(value, validationCriteria.regex)) {
        validationResult.isValid = false;
        validationResult.regexValid = false;
        return validationResult;
      }
      // checking value with the configured minimum length
      else if (value.length < validationCriteria.minLength) {
        validationResult.isValid = false;
        validationResult.minLengthValid = false;
        return validationResult;
      }
      // checking value with the configured maximum length
      else if (value.length > validationCriteria.maxLength) {
        validationResult.isValid = false;
        validationResult.maxLengthValid = false;
        return validationResult;
      } else {
        validationResult.isValid = true;
      }
    }
    // returning the result after the validation
    return validationResult;
  },
  validateDate(value) {
    return RegexUtils.isValid(value, RegexUtils.regexes.dateSlashFormat);
  },
  /**
   * Is the given date before a set limit?
   *
   * @param  {String}  value  The field value.
   * @param  {String}  target The boundary date string.
   * @return {Boolean}        True if value is before.
   */
  isBefore(value, target) {
    const valueMoment = DateUtils.getMomentFromDateString(value);
    const targetMoment = DateUtils.getMomentFromDateString(target);

    return valueMoment.isBefore(targetMoment);
  },

  /**
   * Is the given date afer a set limit?
   *
   * @param  {String|Moment}  value  The field value.
   * @param  {String|Moment}  target The boundary date string.
   * @return {Boolean}        True if value is after.
   */
  isAfter(value, target) {
    const valueMoment = moment.isMoment(value)
      ? value
      : DateUtils.getMomentFromDateString(value);
    const targetMoment = moment.isMoment(target)
      ? target
      : DateUtils.getMomentFromDateString(target);

    return valueMoment.isAfter(targetMoment);
  },
};

export default ValidationConfig;
